import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { Container, Grid, Card, Icon, Header, Segment } from 'semantic-ui-react';
import './Playbook.css';

class Playbook extends Component {
    render() {
        const playbookSections = [
            {
                title: 'Building the Message',
                description: 'Learn how to create compelling sales decks and messaging that creates corporate credibility and differentiates your company.',
                icon: 'bullhorn',
                path: '/playbook/building-message',
                color: 'blue'
            },
            {
                title: 'Onboarding/Training',
                description: 'Comprehensive training process for sales team members to master your company messaging and sales techniques.',
                icon: 'graduation cap',
                path: '/playbook/onboarding-training',
                color: 'green'
            },
            {
                title: 'Sales Activity',
                description: 'Master the art of prospecting, meeting control, and intentional sales interactions across all communication channels.',
                icon: 'chart line',
                path: '/playbook/sales-activity',
                color: 'orange'
            },
            {
                title: 'Closing',
                description: 'Learn to create effective proposals that serve as powerful sales tools and help you close deals successfully.',
                icon: 'handshake outline',
                path: '/playbook/closing',
                color: 'teal'
            },
            {
                title: 'Skills, Orgs & Leadership',
                description: 'Understand compensation plans, organizational structures, and leadership strategies for building high-performing sales teams.',
                icon: 'users',
                path: '/playbook/skills-leadership',
                color: 'purple'
            }
        ];

        return (
            <Container className="playbook-container">
                <Header as="h1" className="playbook-main-header">
                    <Icon name="book" />
                    Sales Playbook
                </Header>
                
                <Segment className="playbook-intro">
                    <p>
                        Welcome to the Multiply Sales Management Framework Playbook. This comprehensive guide will help you 
                        master every aspect of the sales process, from creating compelling messages to building high-performing 
                        sales teams. Each section contains detailed strategies, examples, and actionable insights proven to 
                        drive results.
                    </p>
                </Segment>

                <Grid stackable columns={2} className="playbook-grid">
                    {playbookSections.map((section, index) => (
                        <Grid.Column key={index}>
                            <Card as={Link} to={section.path} className="playbook-section-card" fluid>
                                <Card.Content>
                                    <Card.Header>
                                        <Icon name={section.icon} color={section.color} size="large" />
                                        {section.title}
                                    </Card.Header>
                                    <Card.Description>
                                        {section.description}
                                    </Card.Description>
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                    ))}
                </Grid>
            </Container>
        );
    }
}

export default observer(Playbook);